import { render, staticRenderFns } from "./downloadBulk.vue?vue&type=template&id=06394490&"
import script from "./downloadBulk.vue?vue&type=script&lang=js&"
export * from "./downloadBulk.vue?vue&type=script&lang=js&"
import style0 from "./downloadBulk.vue?vue&type=style&index=0&id=06394490&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports